import React from "react";
import GojsCanvas from "../../../components/goJs/gojsCanvas";

const WealthMapPreview = ({ internalization, ownershipStructure, onOwnershipStructureChange }) => (
  <div className="main-wrapper ownership estate-mapping__wealth-map-preview">
    <GojsCanvas
      isHome={false}
      isMobile={false}
      isEstateMapping={true}
      internalization={internalization}
      palettes={{}}
      ownership_structure={ownershipStructure}
      getListElement={() => null}
      createWildCardStructure={() => null}
      deleteNode={() => null}
      editElement={() => null}
      getPalettes={() => null}
      isNew={false}
      location="props.location"
      history="props.history"
      fetch={() => null}
      inputs_creation={{}}
      showModalCreation={() => null}
      setDiagram={() => null}
      removeLastElement={false}
      updateAutomaticLayout={() => null}
      currentAutomaticLayout="props.user.ownership_automatic_layout_enabled"
      avatar="props.user.avatar_real_user"
      saveOwnershipStructure={(ownership_structure, success) => {
        onOwnershipStructureChange(ownership_structure.ownership_structure);
        success({ ownership_structure: ownership_structure.ownership_structure });
      }}
    />
  </div>
);

export default WealthMapPreview;
